






































import Vue from "vue";

export default Vue.extend({
    name: "MyClassCard",
    props: {
        myClassItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            classImage: require("@/assets/class.png")
        };
    },
    methods: {
        goClassDetail() {
            this.$emit("goClassDetail", { classId: this.myClassItem.id });
        }
    }
});
